import { render, staticRenderFns } from "./CustomerFeedbackDialog.vue?vue&type=template&id=57067814&scoped=true"
import script from "./CustomerFeedbackDialog.vue?vue&type=script&lang=js"
export * from "./CustomerFeedbackDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomerFeedbackDialog.vue?vue&type=style&index=0&id=57067814&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57067814",
  null
  
)

export default component.exports